import { render, staticRenderFns } from "./icon-search.vue?vue&type=template&id=7064f766&"
import script from "./icon-search.vue?vue&type=script&lang=js&"
export * from "./icon-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports